var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card-text",
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "title font-weight-regular" },
        [
          _vm._v("Documents\n    "),
          _c(
            "v-menu",
            {
              attrs: {
                "close-on-content-click": false,
                "close-on-click": false,
                "offset-x": "",
                "nudge-width": 200,
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        "SecondaryBtn",
                        _vm._g(
                          {
                            attrs: { small: "", icon: "add", color: "success" },
                          },
                          on
                        ),
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("Button.AddDocumentReference")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.addMenu,
                callback: function ($$v) {
                  _vm.addMenu = $$v
                },
                expression: "addMenu",
              },
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _vm._v(
                        "\n          Please enter the correct url of the document.\n          "
                      ),
                      _c("v-text-field", {
                        attrs: { label: "Document URL", "single-line": "" },
                        model: {
                          value: _vm.inputUrl,
                          callback: function ($$v) {
                            _vm.inputUrl = $$v
                          },
                          expression: "inputUrl",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "Note", "single-line": "" },
                        model: {
                          value: _vm.inputNote,
                          callback: function ($$v) {
                            _vm.inputNote = $$v
                          },
                          expression: "inputNote",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "PrimaryBtn",
                        {
                          attrs: {
                            small: "",
                            icon: "add",
                            color: "success",
                            disabled: !_vm.inputUrl,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addDocument()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Add")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "SecondaryBtn",
                        {
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.closeAndClear()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.documents, function (document, index) {
        return _c(
          "span",
          { key: index, staticClass: "mr-1" },
          [
            _c(
              "v-btn",
              {
                staticClass: "mx-0",
                attrs: {
                  depressed: "",
                  small: "",
                  href: `/uploads/${document.FileName}`,
                  download: "",
                },
              },
              [
                _c("v-icon", { staticClass: "mr-1" }, [_vm._v("save_alt")]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.getFileName(document.FileName)) +
                    "\n    "
                ),
              ],
              1
            ),
            _vm._v(" "),
            document.Notes && document.Notes.length > 0
              ? _c("span", { staticClass: "mx-0 span-color" }, [
                  _vm._v("Note: " + _vm._s(document.Notes)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "mx-0",
                attrs: { icon: "" },
                on: {
                  click: function ($event) {
                    return _vm.removeDocument(document)
                  },
                },
              },
              [
                _c("v-icon", { attrs: { color: "error" } }, [
                  _vm._v("link_off"),
                ]),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }